import React, { useEffect, useMemo, useState } from "react";
import { Col, Icon } from "antd";
import { getModuleAdvancedSearchConfig } from "../../../../../dataConfig";
import {
  handleSearchControl,
  handleSearchPage
} from "../../../../../routes/Search";
import { getRecentSearchQuery, isObject } from "../../../../../services";
import SearchControls from "./SearchControls";
import { filterGroupsByCondition, getHiddenFieldNames, removeHiddenFields } from "../../../../../utils/searchFilterConditions";
import styles from "./styles.scss";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentCategory } from "../../../../App/selectors";
import { updateCurrentCategory } from "../../../../App/actions";
import { LoadingFilterSection } from "../LoadingFilterSection";

const FilterSection = props => {
  const {
    categories,
    controls: groups,
    isMobile,
    numberOfControls,
    renderSearchBtn,
    selectedCategory,
    resetFields,
    category,
    normaliseSearchValues
  } = props;
  const [submitData, setSubmitData] = useState(getRecentSearchQuery(category));
  const [showAllControls, setShowAllControls] = useState(false);

  const filteredGroups = useMemo(
    () => filterGroupsByCondition(groups, submitData),
    [groups, submitData]
  );

  const dispatch = useDispatch();

  const currentCategory = useSelector(selectCurrentCategory);

  useEffect(() => {
    if (category != currentCategory) {
      dispatch(updateCurrentCategory(category));
    }
  }, [currentCategory, category]);

  const openAllSearch = () => {
    setShowAllControls(true);
  };

  const closeAllSearch = () => {
    setShowAllControls(false);
  };

  const handleSubmit = () => {
    const hiddenFields = getHiddenFieldNames(groups, submitData);
    const filteredData = removeHiddenFields(submitData, hiddenFields);
    props.onSubmit({ ...normaliseSearchValues(filteredData), selectedCategory });
  };

  const handleValuesChange = (values: any) => {
    setSubmitData({});
    let temp: any = { ...submitData, category };
    delete temp.includeMakeIds;
    delete temp.includeModelIds;
    isObject(values) &&
      Object.keys(values).forEach(key => {
        temp = { ...temp, ...values[key] };
        if (isObject(values[key]) && Object.keys(values[key]).includes("categoryLv2Ids")) {
          delete temp.categoryLv1Ids;
        } else if (isObject(values[key]) && Object.keys(values[key]).includes("categoryLv1Ids")) {
          delete temp.categoryLv2Ids;
        }
      });
    setSubmitData(temp);
  };

  const resetFormFields = () => {
    setSubmitData({});
  };

  return filteredGroups.length > 0 ? (
    <div className={isMobile ? styles.sectionContainerMobile : null}>
      <div className={isMobile ? styles.containerMobile : styles.container}>
        <SearchControls
          // @ts-ignore
          categories={categories}
          closeAllSearch={closeAllSearch}
          groups={filteredGroups}
          isMobile={isMobile}
          numberOfControls={numberOfControls}
          onSubmit={handleSubmit}
          onValuesChange={handleValuesChange}
          renderSearchBtn={renderSearchBtn}
          resetFormFields={resetFormFields}
          selectedCategory={selectedCategory}
          showAllControls={showAllControls}
          setShowAllControls={setShowAllControls}
          resetFields={resetFields}
          categoryHr={category || selectedCategory}
        />
      </div>
      {(!showAllControls && groups && groups.length > 1) && (
        <div className={styles.colapseTitleWrapper}>
          <Col
            className={styles.container}
            role="link"
            tabIndex={0}
            onClick={openAllSearch}
            sm={24}
          >
            <span className={styles.moreOptions}>{"Više opcija filtriranja"}</span>
            <Icon
              type="right"
              className={`more-search-arrow ${styles.arrow}`}
            />
          </Col>
        </div>
      )}
    </div>

  ) : (
    <LoadingFilterSection style={{ margin: 0, marginBottom: 30 }} />
  )
};

export default handleSearchPage(
  handleSearchControl(FilterSection, getModuleAdvancedSearchConfig)
);



// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel1/SubLevel1Desktop/FilterSection/index.tsx